// Relativ la origin, ca să funcționeze și local/Docker, nu doar pe contalearn.ro
export const LOGIN_REDIRECT_URL = '/login';

export const redirectToLogin = () => {
  if (typeof window === 'undefined') {
    return;
  }

  if (window.location.pathname === '/login') {
    return;
  }

  window.location.assign(LOGIN_REDIRECT_URL);
};